import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import instagram from "../../assets/images/instagram.svg";
import linkedin from "../../assets/images/linkedinOutline.svg";

import { request } from "../../util";
import "./footer.css";

export const Footer = () => {
   const [footer, setFooter] = useState([]);

   useEffect(() => {
      const getData = async () => {
         try {
            const data = await request.post("/page/search", {
               slug: "footer"
            });
            setFooter(JSON.parse(data.data.data.page.content));
         } catch (error) {
            console.log(error.response);
         }
      };
      getData();
   }, []);

   if (footer.length === 0) {
      return <div>Loading...</div>;
   }

   const [brand, company, platform, legal, contact] = footer.rows[0];
   return (
      <div className="kv-footer">
         <section className="row">
            {/* Brand */}
            <div className="col-xl-3 col-lg-6 col-md-6 mb-4">
               <Link to="/">
                  <img src={brand.components.images[0]?.url} alt="logo" className="mb-5" />
               </Link>

               <p>{brand.components.texts.find((t) => t.key === "description")?.text}</p>
            </div>

            {/* Company */}
            <div className="col-xl-2 col-lg-6 col-md-6 col-sm-6 col-6 mb-4">
               <ul>
                  {company.components.links.map((link, i) => (
                     <li key={i}>
                        <Link to={link.to}>{link.label}</Link>
                     </li>
                  ))}
               </ul>
            </div>

            {/* Platform */}
            <div className="col-xl-2 col-lg-6 col-md-6 col-sm-6 col-6 mb-4">
               <ul>
                  {platform.components.links.map((link, i) => (
                     <li key={i}>
                        <Link to={link.to}>{link.label}</Link>
                     </li>
                  ))}
               </ul>
            </div>

            {/* Legal */}
            <div className="col-xl-2 col-lg-2 col-md-6 col-sm-6 mb-4">
               <ul>
                  {legal.components.links.map((link, i) => (
                     <li key={i}>
                        {link.to ? (
                           <Link to={link.to}>{link.label}</Link>
                        ) : (
                           <a href={link.href} target="_blank" rel="noreferrer">
                              {link.label}
                           </a>
                        )}
                     </li>
                  ))}
               </ul>
            </div>

            {/* Contact */}
            <div className="col-xl-3 col-lg-6 col-md-6 col-sm-6 mb-4">
               <ul>
                  {/* Email */}
                  {contact.components.links
                     .filter((l) => l.type === "email")
                     .map((item, i) => (
                        <li key={i}>
                           <a href={item.href} className="mail-to">
                              {item.label}
                           </a>
                        </li>
                     ))}

                  {/* Addresses */}
                  {contact.components.texts
                     .filter((t) => t.key.includes("address"))
                     .map((t, i) => (
                        <li key={i}>{t.text}</li>
                     ))}

                  {/* Phones */}
                  {contact.components.links
                     .filter((l) => l.type === "phone")
                     .map((item, i) => (
                        <li key={i}>
                           <a href={item.href}>{item.label}</a>
                        </li>
                     ))}

                  {/* Socials */}
                  <li className="d-flex align-items-center">
                     {contact.components.links
                        .filter((l) => l.icon)
                        .map((item, i) => (
                           <a
                              key={i}
                              href={item.href}
                              target="_blank"
                              rel="noreferrer"
                              className={i > 0 ? "mx-4" : ""}
                           >
                              <img
                                 src={item.icon === "instagram" ? instagram : linkedin}
                                 alt={item.label}
                              />
                           </a>
                        ))}
                  </li>
               </ul>
            </div>
         </section>
      </div>
   );
};
